import { CheckCircle, Info, CircleNotch, XCircle, Warning } from "@phosphor-icons/react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      offset={{ bottom: "32px", right: "16px" }}
      icons={{
        success: <CheckCircle size={16} />,
        info: <Info size={16} />,
        warning: <Warning size={16} />,
        error: <XCircle size={16} />,
        loading: <CircleNotch size={16} className="animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };